module.exports = __webpack_public_path__ + "static/img/player_01_program.257b120.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/player_01_program.svg
// module id = b4Nl
// module chunks = 0